import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';
import { APIClientService } from './api-client.service';
import { AppConfigurationService } from './app-configuration.service';
import { EventsManagerService } from './events-manager.service';
import { HttpInterceptor } from './http-interceptor.service';

export type RheemDevicePayload = {
  username: string;
  password: string;
  rheemId: number;
  parents: {
    location: any[]
  }
};

@Injectable()
export class RheemDRService extends APIClientService {

  constructor(
    http: HttpInterceptor,
    authService: AuthService,
    eventsService: EventsManagerService,
    AppConfiguration: AppConfigurationService,
    injector: Injector
  ) {
    super(
      'rheem-dr',
      http,
      authService,
      eventsService,
      AppConfiguration,
      injector
    );
  }
  public discoverDevices(username: string, password: string): Observable<any> {
    return this.post('discover', { username, password });
  }

  public registerDevice(devicePayload: RheemDevicePayload) {
    return this.post('register', devicePayload);
  }

  public registerDevices(devicesPayload: RheemDevicePayload[]): Array<Observable<any>> {
    return devicesPayload.map((d) => this.registerDevice(d));
  }

}
